import { FormattedMessage } from "react-intl";
import React from "react";

export const NODE_PLACE_MODE = {
  centerAndEdge: "centerAndEdge",
  center: "center",
  edge: "edge",
};

export const selectOpts = [
  {
    value: "centerAndEdge",
    label: (
      <FormattedMessage
        id="sna.sidebar.adjusttool.node.placement.progressive"
        defaultMessage="層次擴散"
      />
    ),
  },
  {
    value: "center",
    label: (
      <FormattedMessage
        id="sna.sidebar.adjusttool.node.placement.center"
        defaultMessage="中島模式"
      />
    ),
  },
  {
    value: "edge",
    label: (
      <FormattedMessage
        id="sna.sidebar.adjusttool.node.placement.outlined"
        defaultMessage="周圍模式"
      />
    ),
  },
];
